import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/*
 * cn(): yhdista Tailwind-luokkia konditionaalisesti ilman ristiriitoja.
 *
 * clsx kasittelee falsy-arvot ja objektisyntaksin:
 *   cn('p-2', isActive && 'bg-sammal', { 'opacity-50': isDisabled })
 *
 * tailwind-merge ratkaisee Tailwind-luokkien konfliktit (viimeinen voittaa):
 *   cn('p-2', 'p-4')  -> 'p-4'
 *   cn('text-red-500', 'text-blue-500')  -> 'text-blue-500'
 *
 * Tama on pakollinen apuri kun komponenteilla on `className`-prop joka
 * voi yliajaa default-tyyleja. Ilman twMergea: 'p-2 p-4' jaa molemmiksi
 * ja Tailwind-class-jarjestys ratkaisee mielivaltaisesti, mika rikkoo
 * deterministisyyden.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
